/* eslint-disable max-len */
/* eslint-disable tailwindcss/no-arbitrary-value */
import React, {
  lazy,
  Suspense,
  useEffect,
  useState,
  useRef
} from 'react';
import { arrayOf, shape, func } from 'prop-types';
import { Popover, Button, Chip } from '@one-thd/sui-atomic-components';
import { Close } from '@one-thd/sui-icons';

import { EMPTY_FILTER_DATA } from '../../../utils/constants';
import RebateTooltipTitle from '../rebate-tooltip/RebateTooltipTitle';

const RebateTooltipLazy = lazy(() => import(
  /* webpackChunkName: "rebateTooltip" */
  '../rebate-tooltip/RebateTooltip'
));

export const RebateFilterButton = ({
  filterOptions,
  filterData,
  setFilterData
}) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  const [checkboxGroup, setCheckboxGroup] = useState({});

  const handleFilterClick = (filter) => {
    setCheckboxGroup((prev) => ({
      ...prev,
      [filter]: !checkboxGroup[filter]
    }));
  };

  const handleClear = () => {
    setCheckboxGroup({});
  };

  useEffect(() => {
    const appliedFilters = {};

    Object.values(checkboxGroup).forEach(({ isToggled, filterCategory, filterChoiceID }) => {
      if (isToggled) {
        let currentCategoryFilters = appliedFilters[filterCategory] || [];

        appliedFilters[filterCategory] = [...currentCategoryFilters, filterChoiceID];
      }
    });

    if (Object.keys(filterData.appliedFilters).length || Object.keys(appliedFilters).length) {
      setFilterData((prev) => ({ ...prev, appliedFilters }));
    }
  }, [checkboxGroup]);

  useEffect(() => {
    if (filterData === EMPTY_FILTER_DATA) setCheckboxGroup({});
  }, [filterData]);

  const selections = Object.entries(checkboxGroup).filter(([, { isToggled }]) => isToggled);

  return (
    <div data-testid="rebate-filter" className="sui-flex sui-flex-wrap sui-gap-2 sui-items-center sui-pt-[20px] sui-min-h-[50px]">
      {typeof window !== 'undefined'
        && (
          <Suspense fallback={<div />}>
            <Button
              ref={anchorRef}
              id="focus-button"
              onClick={handleToggle}
              fullWidth={false}
              data-testid="rebate-filter-button"
            >
              Filter
            </Button>
            <Popover
              open={open}
              anchorEl={anchorRef.current}
              onClose={handleClose}
              placement="bottom"
              title={<RebateTooltipTitle handleClear={handleClear} />}
              className="sui-z-[9000]"
            >
              <RebateTooltipLazy
                filterOptions={filterOptions}
                checkboxGroup={checkboxGroup}
                setCheckboxGroup={setCheckboxGroup}
              />
            </Popover>
          </Suspense>
        )}
      {selections.map(([filter], checkedFilterIndex) => (
        <Chip
          className="sui-border-0 sui-bg-[#eee] sui-rounded-full sui-h-[30px] sui-text-xs"
          label={<span className="sui-font-regular sui-text-xs">{filter}</span>}
          key={checkedFilterIndex}
          rounded
          onClick={() => { handleFilterClick(filter); }}
          endIcon={<Close color="danger" className="sui-h-2 sui-w-2" />}
        />

      ))}
    </div>
  );
};

RebateFilterButton.propTypes = {
  filterOptions: arrayOf(shape({})).isRequired,
  filterData: shape({
    currentFilters: shape({})
  }).isRequired,
  setFilterData: func.isRequired
};

RebateFilterButton.displayName = 'RebateFilterButton';

RebateFilterButton.defaultProps = {};
